import { h } from '@debbie/cortex/dist/index.js';
import { useVoucherApplications } from '@debbie/cortex/dist/voucher-applications/index.js';
import React from 'react';
import { styled } from 'styled-components';
import VoucherApplication from './VoucherApplication.js';
const VoucherApplications = (props) => {
    const voucherApplications = useVoucherApplications();
    const relevantCreditorId = props.creditorId || null;
    return (React.createElement(Wrapper, null, h.hasData(voucherApplications)
        ? voucherApplications.data
            .filter((va) => va.creditorId == relevantCreditorId)
            .map((va) => {
            return React.createElement(VoucherApplication, { key: va.id, voucherApplication: va });
        })
        : null));
};
const Wrapper = styled.div ``;
export default VoucherApplications;
//# sourceMappingURL=VoucherApplications.js.map